import { render, staticRenderFns } from "./VImg.vue?vue&type=template&id=6d1ae350&scoped=true&"
import script from "./VImg.vue?vue&type=script&lang=js&"
export * from "./VImg.vue?vue&type=script&lang=js&"
import style0 from "./VImg.vue?vue&type=style&index=0&id=6d1ae350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1ae350",
  null
  
)

export default component.exports